import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from '@mui/material'
import { Link } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import { FiChevronRight, FiPackage } from 'react-icons/fi'
import Filter from '../../components/Filter/Filter'
import Cards from '../../components/cards/Cards'
import '../../styles/categoryPage.css'

const SKELETON_COUNT = 8

const ComptoirContainer = () => {
    const [infob, setInfob] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const items = 20
    const [current, setCurrent] = useState(1)
    const NbPages = Math.ceil(infob.length / items)
    const startInadex = (current - 1) * items
    const endInadex = startInadex + items
    const dataParPage = infob.slice(startInadex, endInadex)

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/comptoir/lister`)
            .then(res => {
                setInfob(res.data)
                setIsLoading(false)
            })
            .catch(() => setIsLoading(false))
    }, [])

    const cards = dataParPage.map(card => {
        return <Cards nom={card.nom} key={card._id} dimension1={card.dimension1} dimension2={card.dimension2} dimension3={card.dimension3} dimension4={card.dimension4} dimension5={card.dimension5} prix1={card.prix1} prix2={card.prix2} prix3={card.prix3} prix4={card.prix4} prix5={card.prix5} titre={card.titre} reference={card.reference} description={card.description} prix={card.prix} disponibilité={card.disponibilite} image={card.image} id={card._id} />
    })

    const HandelFilter = (filterValue) => {
        const sorted = [...infob]

        if (filterValue === "prixCroissent") {
            sorted.sort((a, b) => a.prix - b.prix)
        } else if (filterValue === "prixDecroissent") {
            sorted.sort((a, b) => b.prix - a.prix)
        } else if (filterValue === "nomA") {
            sorted.sort((a, b) => a.titre.toUpperCase().localeCompare(b.titre.toUpperCase()))
        } else if (filterValue === "nomZ") {
            sorted.sort((a, b) => b.titre.toUpperCase().localeCompare(a.titre.toUpperCase()))
        } else {
            sorted.sort((a, b) => (a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0))
        }

        setInfob(sorted)
        setCurrent(1)
    }

    const Handelchange = (event, page) => {
        setCurrent(page)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <div className='container hd-catpage'>
            <motion.nav
                className="hd-breadcrumb"
                aria-label="breadcrumb"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4 }}
            >
                <Link to="/">Accueil</Link>
                <FiChevronRight />
                <span>Comptoir d'accueil</span>
            </motion.nav>

            <motion.div
                className="hd-catpage-header"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.05 }}
            >
                <h1 className="hd-catpage-title">Comptoir d'accueil</h1>
                <p className="hd-catpage-count">
                    {isLoading ? 'Chargement…' : `${infob.length} ${infob.length > 1 ? 'articles' : 'article'}`}
                </p>
            </motion.div>

            <div className="hd-catpage-toolbar">
                <Filter functionFilter={HandelFilter} />
            </div>

            {isLoading ? (
                <div className="row">
                    {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
                        <div className="col-lg-3 col-md-4 col-6 mb-4" key={i}>
                            <div className="hd-skeleton-card">
                                <div className="hd-skeleton-media" />
                                <div className="hd-skeleton-line hd-skeleton-line-lg" />
                                <div className="hd-skeleton-line hd-skeleton-line-sm" />
                            </div>
                        </div>
                    ))}
                </div>
            ) : infob.length === 0 ? (
                <motion.div className="hd-catpage-empty" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
                    <FiPackage />
                    <p>Aucun article disponible pour le moment.</p>
                </motion.div>
            ) : (
                <AnimatePresence mode="wait">
                    <motion.div
                        className='row'
                        key={current}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        {cards}
                    </motion.div>
                </AnimatePresence>
            )}

            {NbPages > 1 && (
                <div className='container justify-content-center d-flex mt-5 hd-catpage-pagination'>
                    <Pagination color="secondary" count={NbPages} page={current} onChange={Handelchange} />
                </div>
            )}
        </div>
    )
}

export default ComptoirContainer
